<template>
    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <div class="section text-center" v-if="!loading_list">
        <b class="text-danger" v-if="!editable">{{ $t('not_editable') }}</b>
    </div>
    <div class="section pt-1 mt-1" v-if="!loading_list">
        <Form @submit="handleFormSubmit" @invalid-submit="onInvalidSubmit" :validation-schema="schema"
            :initial-values="initialValues">
            <div class="form-grid">
                <!-- Basic Information -->
                <div class="form-card">
                    <div class="form-card-header">{{ $t('basic_information') }}</div>
                    <div class="form-card-body">
                        <div class="form-group">
                            <label>{{ $t('has_centre') }}</label>
                            <div class="radio-group">
                                <span class="radio-option">
                                    <Field name="has_center" type="radio" value="yes" v-model="has_center"
                                        id="center-yes" />
                                    <label for="center-yes">{{ $t('yes_2') }}</label>
                                </span>
                                <span class="radio-option">
                                    <Field name="has_center" type="radio" value="no" v-model="has_center"
                                        id="center-no" />
                                    <label for="center-no">{{ $t('no_2') }}</label>
                                </span>
                            </div>
                            <ErrorMessage name="has_center" class="error-message" />
                        </div>
                        <div class="form-group" v-if="has_center === 'yes'">
                            <label>{{ $t('building_type') }}</label>
                            <Field name="center_type" as="select" class="form-control" v-model="center_type">
                                <option value="">{{ $t('select_option') }}</option>
                                <option value="own">{{ $t('own') }}</option>
                                <option value="rent">{{ $t('rent') }}</option>
                                <option value="worker_home">{{ $t('worker_home') }}</option>
                                <option value="others">{{ $t('others') }}</option>
                            </Field>
                            <ErrorMessage name="center_type" class="error-message" />
                        </div>
                        <div class="form-group" v-if="has_center === 'yes'">
                            <label>{{ $t('office_location') }}</label>
                            <Field name="office_location" type="text" class="form-control"
                                :placeholder="$t('enter_office_location')" v-model="office_location" />
                            <ErrorMessage name="office_location" class="error-message" />
                        </div>
                    </div>
                </div>

                <!-- Masjid Details - FIXED VERSION -->
                <div class="form-card">
                    <div class="form-card-header">
                        {{ $t('masjid_details') }}
                    </div>
                    <div class="form-card-body">
                        <div v-if="masjids.length === 1" class="form-group">
                            <label class="label">{{ $t('has_masjid_mujahid') }}</label>
                            <div class="radio-group">
                                <span class="radio-option">
                                    <Field name="masjids[0].has_masjid" type="radio" value="yes"
                                        v-model="masjids[0].has_masjid" />
                                    <label>{{ $t('yes_2') }}</label>
                                </span>
                                <span class="radio-option">
                                    <Field name="masjids[0].has_masjid" type="radio" value="no"
                                        v-model="masjids[0].has_masjid" />
                                    <label>{{ $t('no_2') }}</label>
                                </span>
                            </div>
                            <ErrorMessage name="masjids[0].has_masjid" class="error-message" />
                        </div>

                        <!-- Show masjid forms only if first entry has_masjid is 'yes' -->
                        <div v-if="masjids[0].has_masjid === 'yes'">
                            <div v-for="(masjid, idx) in masjids" :key="idx" class="masjid-section">
                                <div class="mb-2" style="font-weight: bold; color: #003772;">{{ $t('masjid') }} {{ idx + 1 }}</div>

                                <!-- Common form fields for all masjids -->
                                <div class="form-group">
                                    <label class="label">{{ $t('masjid_affiliation') }}</label>
                                    <Field :name="`masjids[${idx}].masjid_affiliation`" as="select" class="form-control"
                                        v-model="masjid.masjid_affiliation">
                                        <option value="">{{ $t('select_option') }}</option>
                                        <option value="wisdom">{{ $t('wisdom') }}</option>
                                        <option value="knm">{{ $t('knm') }}</option>
                                        <option value="markaz">{{ $t('markaz') }}</option>
                                        <option value="others">{{ $t('others') }}</option>
                                    </Field>
                                    <ErrorMessage :name="`masjids[${idx}].masjid_affiliation`" class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('masjid_location') }}</label>
                                    <Field :name="`masjids[${idx}].masjid_location`" type="text" class="form-control"
                                        :placeholder="$t('enter_masjid_location')" v-model="masjid.masjid_location" />
                                    <ErrorMessage :name="`masjids[${idx}].masjid_location`" class="error-message" />
                                </div>

                                <!-- <div class="form-group" v-if="masjid.masjid_affiliation === 'wisdom'">
                                <label class="label">Wisdom Location</label>
                                <Field :name="`masjids[${idx}].wisdom_location`" type="text" class="form-control" placeholder="Enter wisdom location" v-model="masjid.wisdom_location" />
                                <ErrorMessage :name="`masjids[${idx}].wisdom_location`" class="error-message" />
                            </div> -->

                                <div class="form-group">
                                    <label class="label">{{ $t('has_jumua') }}</label>
                                    <div class="radio-group">
                                        <span class="radio-option">
                                            <Field :name="`masjids[${idx}].has_jumua`" type="radio" value="yes"
                                                v-model="masjid.has_jumua" />
                                            <label>{{ $t('yes') }}</label>
                                        </span>
                                        <span class="radio-option">
                                            <Field :name="`masjids[${idx}].has_jumua`" type="radio" value="no"
                                                v-model="masjid.has_jumua" />
                                            <label>{{ $t('no') }}</label>
                                        </span>
                                    </div>
                                    <ErrorMessage :name="`masjids[${idx}].has_jumua`" class="error-message" />
                                </div>

                                <div class="form-group" v-if="masjid.has_jumua === 'yes'">
                                    <label class="label">{{ $t('jumua_attendance') }}</label>
                                    <Field :name="`masjids[${idx}].jumua_attendance`" as="select" class="form-control"
                                        v-model="masjid.jumua_attendance">
                                        <option value="">{{ $t('select_range') }}</option>
                                        <option value="under_100">{{ $t('under_100') }}</option>
                                        <option value="100_300">{{ $t('between_100_300') }}</option>
                                        <option value="300_500">{{ $t('between_300_500') }}</option>
                                        <option value="500_1000">{{ $t('between_500_1000') }}</option>
                                        <option value="1000_plus">{{ $t('above_1000') }}</option>
                                    </Field>
                                    <ErrorMessage :name="`masjids[${idx}].jumua_attendance`" class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('parking_capacity') }}</label>
                                    <Field :name="`masjids[${idx}].parking_capacity`" type="number" class="form-control"
                                        :placeholder="$t('enter_parking_capacity')" v-model="masjid.parking_capacity" />
                                    <ErrorMessage :name="`masjids[${idx}].parking_capacity`" class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('facilities') }}</label>
                                    <div class="checkbox-group">
                                        <label>
                                            <Field :name="`masjids[${idx}].facilities`" type="checkbox" value="women"
                                                v-model="masjid.facilities" /> {{ $t('women_facility') }}
                                        </label>
                                        <label>
                                            <Field :name="`masjids[${idx}].facilities`" type="checkbox"
                                                value="meeting_hall" v-model="masjid.facilities" /> {{ $t('meeting_hall') }}
                                        </label>
                                        <label>
                                            <Field :name="`masjids[${idx}].facilities`" type="checkbox" value="ac"
                                                v-model="masjid.facilities" /> {{ $t('ac_facility') }}
                                        </label>
                                    </div>
                                    <ErrorMessage :name="`masjids[${idx}].facilities`" class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('staff_count') }}</label>
                                    <Field :name="`masjids[${idx}].masjid_staff_count`" type="number"
                                        class="form-control" :placeholder="$t('enter_staff_count')"
                                        v-model="masjid.masjid_staff_count" />
                                    <ErrorMessage :name="`masjids[${idx}].masjid_staff_count`" class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('imam_name') }}</label>
                                    <Field :name="`masjids[${idx}].imam_name`" type="text" class="form-control"
                                        :placeholder="$t('enter_imam_name')" v-model="masjid.imam_name" />
                                    <ErrorMessage :name="`masjids[${idx}].imam_name`" class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('imam_state') }}</label>
                                    <Field :name="`masjids[${idx}].imam_state`" type="text" class="form-control"
                                        :placeholder="$t('enter_imam_state')" v-model="masjid.imam_state" />
                                    <ErrorMessage :name="`masjids[${idx}].imam_state`" class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('imam_phone') }}</label>
                                    <Field :name="`masjids[${idx}].imam_phone`" type="tel" class="form-control"
                                        :placeholder="$t('enter_imam_phone')" v-model="masjid.imam_phone" />
                                    <ErrorMessage :name="`masjids[${idx}].imam_phone`" class="error-message" />
                                </div>

                                <!-- Action buttons -->
                                <div class="d-flex justify-content-between align-items-center mt-2">
                                    <button v-if="masjids.length > 1" type="button" class="btn btn-danger btn-sm"
                                        @click="removeMasjid(idx)">{{ $t('remove') }}</button>
                                    <div></div>
                                    <button v-if="idx === masjids.length - 1" type="button"
                                        class="btn btn-sm btn-success ms-auto" @click="addMasjid">{{ $t('add_masjid') }}</button>
                                </div>
                                <hr v-if="idx < masjids.length - 1" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Madrasa Details - FIXED VERSION -->
                <div class="form-card">
                    <div class="form-card-header">
                        {{ $t('madrasa_details') }}
                    </div>
                    <div class="form-card-body">
                        <div v-if="madrasas.length === 1" class="form-group">
                            <label class="label">{{ $t('has_madrasa_mujahid') }}</label>
                            <div class="radio-group">
                                <span class="radio-option">
                                    <Field name="madrasas[0].has_madrasa" type="radio" value="yes"
                                        v-model="madrasas[0].has_madrasa" />
                                    <label>{{ $t('yes_2') }}</label>
                                </span>
                                <span class="radio-option">
                                    <Field name="madrasas[0].has_madrasa" type="radio" value="no"
                                        v-model="madrasas[0].has_madrasa" />
                                    <label>{{ $t('no_2') }}</label>
                                </span>
                            </div>
                            <ErrorMessage name="madrasas[0].has_madrasa" class="error-message" />
                        </div>

                        <!-- Show madrasa forms only if first entry has_madrasa is 'yes' -->
                        <div v-if="madrasas[0].has_madrasa === 'yes'">
                            <div v-for="(madrasa, idx) in madrasas" :key="idx" class="madrasa-section">
                                <div class="mb-2" style="font-weight: bold; color: #003772;">{{ $t('madrasa') }} {{ idx + 1 }}</div>

                                <!-- Common form fields for all madrasas -->
                                <div class="form-group">
                                    <label class="label">{{ $t('madrasa_affiliation') }}</label>
                                    <Field :name="`madrasas[${idx}].madrasa_affiliation`" as="select"
                                        class="form-control" v-model="madrasa.madrasa_affiliation">
                                        <option value="">{{ $t('select_option') }}</option>
                                        <option value="wisdom">{{ $t('wisdom') }}</option>
                                        <option value="knm">{{ $t('knm') }}</option>
                                        <option value="markaz">{{ $t('markaz') }}</option>
                                        <option value="others">{{ $t('others') }}</option>
                                    </Field>
                                    <ErrorMessage :name="`madrasas[${idx}].madrasa_affiliation`"
                                        class="error-message" />
                                </div>

                                <div class="form-group" v-if="madrasa.madrasa_affiliation === 'wisdom'">
                                    <label class="label">{{ $t('building_type') }}</label>
                                    <Field :name="`madrasas[${idx}].madrasa_building_type`" as="select"
                                        class="form-control" v-model="madrasa.madrasa_building_type">
                                        <option value="">{{ $t('select_option') }}</option>
                                        <option value="own">{{ $t('own') }}</option>
                                        <option value="rent">{{ $t('rent') }}</option>
                                        <option value="others">{{ $t('others') }}</option>
                                    </Field>
                                    <ErrorMessage :name="`madrasas[${idx}].madrasa_building_type`"
                                        class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('madrasa_name') }}</label>
                                    <Field :name="`madrasas[${idx}].madrasa_name`" type="text" class="form-control"
                                        :placeholder="$t('enter_madrasa_name')" v-model="madrasa.madrasa_name" />
                                    <ErrorMessage :name="`madrasas[${idx}].madrasa_name`" class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('madrasa_started_year') }}</label>
                                    <Field :name="`madrasas[${idx}].madrasa_started_year`" type="number"
                                        class="form-control" :placeholder="$t('enter_madrasa_started_year')"
                                        v-model="madrasa.madrasa_started_year" />
                                    <ErrorMessage :name="`madrasas[${idx}].madrasa_started_year`"
                                        class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('class_format') }}</label>
                                    <div class="radio-group">
                                        <span class="radio-option">
                                            <Field :name="`madrasas[${idx}].class_format`" type="radio" value="daily"
                                                v-model="madrasa.class_format" />
                                            <label>{{ $t('daily') }}</label>
                                        </span>
                                        <span class="radio-option">
                                            <Field :name="`madrasas[${idx}].class_format`" type="radio" value="weekly"
                                                v-model="madrasa.class_format" />
                                            <label>{{ $t('weekly') }}</label>
                                        </span>
                                    </div>
                                    <ErrorMessage :name="`madrasas[${idx}].class_format`" class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('madrasa_location') }}</label>
                                    <Field :name="`madrasas[${idx}].madrasa_location`" type="text" class="form-control"
                                        :placeholder="$t('enter_madrasa_location')" v-model="madrasa.madrasa_location" />
                                    <ErrorMessage :name="`madrasas[${idx}].madrasa_location`" class="error-message" />
                                </div>

                                <!-- Action buttons -->
                                <div class="d-flex justify-content-between align-items-center mt-2">
                                    <button v-if="madrasas.length > 1" type="button" class="btn btn-danger btn-sm"
                                        @click="removeMadrasa(idx)">{{ $t('remove') }}</button>
                                    <div></div>
                                    <button v-if="idx === madrasas.length - 1" type="button"
                                        class="btn btn-sm btn-success ms-auto" @click="addMadrasa">{{ $t('add_madrasa') }}</button>
                                </div>
                                <hr v-if="idx < madrasas.length - 1" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Arabic College Details -->
                <div class="form-card">
                    <div class="form-card-header">{{ $t('arabic_college_details') }}</div>
                    <div class="form-card-body">
                        <div class="form-group">
                            <label class="label">{{ $t('has_arabic_college_mujahid') }}</label>
                            <div class="radio-group">
                                <span class="radio-option">
                                    <Field name="has_arabic_college" type="radio" value="yes"
                                        v-model="has_arabic_college" />
                                    <label>{{ $t('yes_2') }}</label>
                                </span>
                                <span class="radio-option">
                                    <Field name="has_arabic_college" type="radio" value="no"
                                        v-model="has_arabic_college" />
                                    <label>{{ $t('no_2') }}</label>
                                </span>
                            </div>
                            <ErrorMessage name="has_arabic_college" class="error-message" />
                        </div>

                        <div v-if="has_arabic_college === 'yes'">
                            <div class="form-group">
                                <label class="label">{{ $t('college_affiliation') }}</label>
                                <Field name="college_affiliation" as="select" class="form-control"
                                    v-model="college_affiliation">
                                    <option value="">{{ $t('select_option') }}</option>
                                    <option value="wisdom">{{ $t('wisdom') }}</option>
                                    <option value="knm">{{ $t('knm') }}</option>
                                    <option value="markaz">{{ $t('markaz') }}</option>
                                    <option value="others">{{ $t('others') }}</option>
                                </Field>
                                <ErrorMessage name="college_affiliation" class="error-message" />
                            </div>

                            <div class="form-group" v-if="college_affiliation === 'wisdom'">
                                <label class="label">{{ $t('college_building_type') }}</label>
                                <Field name="college_building_type" as="select" class="form-control"
                                    v-model="college_building_type">
                                    <option value="">{{ $t('select_option') }}</option>
                                    <option value="own">{{ $t('own') }}</option>
                                    <option value="rent">{{ $t('rent') }}</option>
                                    <option value="others">{{ $t('others') }}</option>
                                </Field>
                                <ErrorMessage name="college_building_type" class="error-message" />
                            </div>

                            <div class="form-group">
                                <label class="label">{{ $t('college_name') }}</label>
                                <Field name="college_name" type="text" class="form-control"
                                    :placeholder="$t('enter_college_name')" v-model="college_name" />
                                <ErrorMessage name="college_name" class="error-message" />
                            </div>

                            <div class="form-group">
                                <label class="label">{{ $t('college_started_year') }}</label>
                                <Field name="college_started_year" type="number" class="form-control"
                                    :placeholder="$t('enter_college_started_year')" v-model="college_started_year" />
                                <ErrorMessage name="college_started_year" class="error-message" />
                            </div>

                            <div class="form-group">
                                <label class="label">{{ $t('course_details') }}</label>
                                <div class="checkbox-group">
                                    <label>
                                        <Field name="courses" type="checkbox" value="plus2" v-model="courses" /> 
                                        {{ $t('plus2') }}
                                    </label>
                                    <label>
                                        <Field name="courses" type="checkbox" value="afsalul_ulama_prelim"
                                            v-model="courses" /> {{ $t('afsalul_ulama_prelim') }}
                                    </label>
                                    <label>
                                        <Field name="courses" type="checkbox" value="afsalul_ulama_final"
                                            v-model="courses" /> {{ $t('afsalul_ulama_final') }}
                                    </label>
                                    <label>
                                        <Field name="courses" type="checkbox" value="others" v-model="courses" />
                                        {{ $t('other') }}
                                    </label>
                                </div>
                                <ErrorMessage name="courses" class="error-message" />
                            </div>

                            <div class="form-group">
                                <label class="label">{{ $t('number_of_teachers') }}</label>
                                <Field name="teacher_count" type="number" class="form-control"
                                    :placeholder="enter_teacher_count" v-model="teacher_count" />
                                <ErrorMessage name="teacher_count" class="error-message" />
                            </div>

                            <div class="form-group">
                                <label class="label">{{ $t('college_location') }}</label>
                                <Field name="college_location" type="text" class="form-control"
                                    :placeholder="$t('enter_college_location')" v-model="college_location" />
                                <ErrorMessage name="college_location" class="error-message" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Social Media Details -->
                <div class="form-card">
                    <div class="form-card-header">{{ $t('social_media_details') }}</div>
                    <div class="form-card-body">
                        <p>{{ $t('social_media_details_unit') }}</p>

                        <div class="form-group">
                            <label class="label">{{ $t('facebook') }}</label>
                            <Field name="facebook_link" type="url" class="form-control" :placeholder="$t('enter_facebook_link')"
                                v-model="facebook_link" />
                            <ErrorMessage name="facebook_link" class="error-message" />
                        </div>

                        <div class="form-group">
                            <label class="label">{{ $t('youtube') }}</label>
                            <Field name="youtube_link" type="url" class="form-control" :placeholder="$t('enter_youtube_link')"
                                v-model="youtube_link" />
                            <ErrorMessage name="youtube_link" class="error-message" />
                        </div>

                        <div class="form-group">
                            <label class="label">{{ $t('instagram') }}</label>
                            <Field name="instagram_link" type="url" class="form-control" :placeholder="$t('enter_instagram_link')"
                                v-model="instagram_link" />
                            <ErrorMessage name="instagram_link" class="error-message" />
                        </div>

                        <div class="form-group">
                            <label class="label">{{ $t('wisdom_media') }}</label>
                            <Field name="wisdom_media_link" type="url" class="form-control"
                                :placeholder="$t('enter_wisdom_media_link')" v-model="wisdom_media_link" />
                            <ErrorMessage name="wisdom_media_link" class="error-message" />
                        </div>
                    </div>
                </div>

                <!-- Land and Building -->
                <div class="form-card">
                    <div class="form-card-header">{{ $t('land_and_building') }}</div>
                    <div class="form-card-body">
                        <div class="form-group">
                            <label class="label">{{ $t('wisdom_land') }}</label>
                            <Field name="wisdom_land_cents" type="number" class="form-control"
                                :placeholder="$t('land_in_cents')" v-model="wisdom_land_cents" />
                            <ErrorMessage name="wisdom_land_cents" class="error-message" />
                        </div>

                        <div class="form-group">
                            <label class="label">{{ $t('trust_land') }}</label>
                            <Field name="trust_land_cents" type="number" class="form-control"
                                :placeholder="$t('enter_trust_land_in_cents')" v-model="trust_land_cents" />
                            <ErrorMessage name="trust_land_cents" class="error-message" />
                        </div>

                        <div class="form-group">
                            <label class="label">{{ $t('other_land') }}</label>
                            <Field name="other_land" type="text" class="form-control" :placeholder="$t('enter_other_land')"
                                v-model="other_land" />
                            <ErrorMessage name="other_land" class="error-message" />
                        </div>
                    </div>
                </div>

                <!-- QHLS Details - FIXED VERSION -->
                <div class="form-card">
                    <div class="form-card-header">{{ $t('qhls_details') }}</div>
                    <div class="form-card-body">
                        <div v-if="qhlsList.length === 1" class="form-group">
                            <label class="label">{{ $t('qhls') }}</label>
                            <div class="radio-group">
                                <span class="radio-option">
                                    <Field name="qhls[0].has_qhls" type="radio" value="yes"
                                        v-model="qhlsList[0].has_qhls" />
                                    <label>{{ $t('yes_2') }}</label>
                                </span>
                                <span class="radio-option">
                                    <Field name="qhls[0].has_qhls" type="radio" value="no"
                                        v-model="qhlsList[0].has_qhls" />
                                    <label>{{ $t('no_2') }}</label>
                                </span>
                            </div>
                            <ErrorMessage name="qhls[0].has_qhls" class="error-message" />
                        </div>

                        <!-- Show QHLS forms only if first entry has_qhls is 'yes' -->
                        <div v-if="qhlsList[0].has_qhls === 'yes'">
                            <div v-for="(qhls, idx) in qhlsList" :key="idx" class="qhls-section">
                                <div class="mb-2" style="font-weight: bold; color: #003772;">{{ $t('qhls') }} {{ idx + 1 }}</div>

                                <!-- Common form fields for all QHLS -->
                                <div class="form-group">
                                    <label class="label">{{ $t('qhls_name') }}</label>
                                    <Field :name="`qhls[${idx}].qhls_name`" type="text" class="form-control"
                                        :placeholder="$t('enter_qhls_name')" v-model="qhls.qhls_name" />
                                    <ErrorMessage :name="`qhls[${idx}].qhls_name`" class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('qhls_location') }}</label>
                                    <Field :name="`qhls[${idx}].qhls_location`" type="text" class="form-control"
                                        :placeholder="$t('enter_qhls_location')" v-model="qhls.qhls_location" />
                                    <ErrorMessage :name="`qhls[${idx}].qhls_location`" class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('convener_name') }}</label>
                                    <Field :name="`qhls[${idx}].qhls_convener_name`" type="text" class="form-control"
                                        :placeholder="$t('enter_convener_name')" v-model="qhls.qhls_convener_name" />
                                    <ErrorMessage :name="`qhls[${idx}].convener_name`" class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('convener_phone') }}</label>
                                    <Field :name="`qhls[${idx}].convener_phone`" type="tel" class="form-control"
                                        :placeholder="$t('enter_convener_phone')" v-model="qhls.qhls_convener_phone" />
                                    <ErrorMessage :name="`qhls[${idx}].qhls_convener_phone`" class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('day') }}</label>
                                    <Field :name="`qhls[${idx}].qhls_day`" as="select" class="form-control"
                                        v-model="qhls.qhls_day">
                                        <option value="">{{ $t('select_day') }}</option>
                                        <option value="Monday">{{ $t('monday') }}</option>
                                        <option value="Tuesday">{{ $t('tuesday') }}</option>
                                        <option value="Wednesday">{{ $t('wednesday') }}</option>
                                        <option value="Thursday">{{ $t('thursday') }}</option>
                                        <option value="Friday">{{ $t('friday') }}</option>
                                        <option value="Saturday">{{ $t('saturday') }}</option>
                                        <option value="Sunday">{{ $t('sunday') }}</option>
                                    </Field>
                                    <ErrorMessage :name="`qhls[${idx}].qhls_day`" class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('time') }}</label>
                                    <div class="d-flex align-items-center">
                                        <Field :name="`qhls[${idx}].qhls_hour`" as="select" class="form-control"
                                            v-model="qhls.qhls_hour" style="max-width: 80px;">
                                            <option value="">{{ $t('hour') }}</option>
                                            <option v-for="h in 12" :key="h" :value="h">{{ h }}</option>
                                        </Field>
                                        <span class="mx-1">:</span>
                                        <Field :name="`qhls[${idx}].qhls_minute`" as="select" class="form-control"
                                            v-model="qhls.qhls_minute" style="max-width: 80px;">
                                            <option v-for="m in 60" :key="m - 1"
                                                :value="(m - 1).toString().padStart(2, '0')">{{
                                                    (m - 1).toString().padStart(2, '0') }}</option>
                                        </Field>
                                        <Field :name="`qhls[${idx}].qhls_period`" as="select" class="form-control ms-2"
                                            v-model="qhls.qhls_period" style="max-width: 80px;">
                                            <option value="AM">AM</option>
                                            <option value="PM">PM</option>
                                        </Field>
                                    </div>
                                    <ErrorMessage :name="`qhls[${idx}].qhls_hour`" class="error-message" />
                                    <ErrorMessage :name="`qhls[${idx}].qhls_minute`" class="error-message" />
                                    <ErrorMessage :name="`qhls[${idx}].qhls_period`" class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('qhls_participants_count') }}</label>
                                    <Field :name="`qhls[${idx}].qhls_participants_count`" type="number"
                                        class="form-control" :placeholder="$t('enter_qhls_participants_count')"
                                        v-model="qhls.qhls_participants_count" />
                                    <ErrorMessage :name="`qhls[${idx}].qhls_participants_count`"
                                        class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('qhls_started_year') }}</label>
                                    <Field :name="`qhls[${idx}].qhls_started_year`" type="number" class="form-control"
                                        :placeholder="$t('enter_qhls_started_year')" v-model="qhls.qhls_started_year" />
                                    <ErrorMessage :name="`qhls[${idx}].qhls_started_year`" class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('building_type') }}</label>
                                    <Field :name="`qhls[${idx}].qhls_building_type`" as="select" class="form-control"
                                        v-model="qhls.qhls_building_type">
                                        <option value="">{{ $t('select_option') }}</option>
                                        <option value="own">{{ $t('own') }}</option>
                                        <option value="rent">{{ $t('rent') }}</option>
                                        <option value="other">{{ $t('other') }}</option>
                                    </Field>
                                    <ErrorMessage :name="`qhls[${idx}].qhls_building_type`" class="error-message" />
                                </div>

                                <div class="form-group">
                                    <label class="label">{{ $t('qhls_frequency') }}</label>
                                    <Field :name="`qhls[${idx}].qhls_frequency`" as="select" class="form-control"
                                        v-model="qhls.qhls_frequency">
                                        <option value="">{{ $t('select_option') }}</option>
                                        <option value="weekly">{{ $t('weekly') }}</option>
                                        <option value="monthly">{{ $t('monthly') }}</option>
                                        <option value="other">{{ $t('other') }}</option>
                                    </Field>
                                    <ErrorMessage :name="`qhls[${idx}].qhls_frequency`" class="error-message" />
                                </div>

                                <!-- Action buttons -->
                                <div class="d-flex justify-content-between align-items-center mt-2">
                                    <button v-if="qhlsList.length > 1" type="button" class="btn btn-danger btn-sm"
                                        @click="removeQhls(idx)">{{ $t('remove') }}</button>
                                    <div></div>
                                    <button v-if="idx === qhlsList.length - 1" type="button"
                                        class="btn btn-sm btn-success ms-auto" @click="addQhls">{{ $t('add_qhls') }}</button>
                                </div>
                                <hr v-if="idx < qhlsList.length - 1" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- CRE -->
                <div class="form-card">
                    <div class="form-card-header">{{ $t('cre_details') }}</div>
                    <div class="form-card-body">
                        <div class="form-group">
                            <label class="label">{{ $t('cre') }}</label>
                            <div class="radio-group">
                                <span class="radio-option">
                                    <Field name="has_cre" type="radio" value="yes" v-model="has_cre" />
                                    <label>{{ $t('yes_2') }}</label>
                                </span>
                                <span class="radio-option">
                                    <Field name="has_cre" type="radio" value="no" v-model="has_cre" />
                                    <label>{{ $t('no_2') }}</label>
                                </span>
                            </div>
                            <ErrorMessage name="has_cre" class="error-message" />
                        </div>

                        <div v-if="has_cre === 'yes'">
                            <div class="form-group">
                                <label class="label">{{ $t('cre_day') }}</label>
                                <Field name="cre_day" as="select" class="form-control" v-model="cre_day">
                                    <option value="">{{ $t('select_day') }}</option>
                                    <option value="Monday">{{ $t('monday') }}</option>
                                    <option value="Tuesday">{{ $t('tuesday') }}</option>
                                    <option value="Wednesday">{{ $t('wednesday') }}</option>
                                    <option value="Thursday">{{ $t('thursday') }}</option>
                                    <option value="Friday">{{ $t('friday') }}</option>
                                    <option value="Saturday">{{ $t('saturday') }}</option>
                                    <option value="Sunday">{{ $t('sunday') }}</option>
                                </Field>
                                <ErrorMessage name="cre_day" class="error-message" />
                            </div>
                            <div class="form-group">
                                <label class="label">{{ $t('time') }}</label>
                                <div class="d-flex align-items-center">
                                    <Field name="cre_hour" as="select" class="form-control" v-model="cre_hour"
                                        style="max-width: 80px;">
                                        <option value="">{{ $t('hour') }}</option>
                                        <option v-for="h in 12" :key="h" :value="h">{{ h }}</option>
                                    </Field>
                                    <span class="mx-1">:</span>
                                    <Field name="cre_minute" as="select" class="form-control" v-model="cre_minute"
                                        style="max-width: 80px;">
                                        <option v-for="m in 60" :key="m - 1"
                                            :value="(m - 1).toString().padStart(2, '0')">{{
                                                (m - 1).toString().padStart(2, '0') }}</option>
                                    </Field>
                                    <Field name="cre_period" as="select" class="form-control ms-2" v-model="cre_period"
                                        style="max-width: 80px;">
                                        <option value="AM">AM</option>
                                        <option value="PM">PM</option>
                                    </Field>
                                </div>
                                <ErrorMessage name="cre_hour" class="error-message" />
                                <ErrorMessage name="cre_minute" class="error-message" />
                                <ErrorMessage name="cre_period" class="error-message" />
                            </div>
                            <div class="form-group">
                                <label class="label">{{ $t('convener_phone') }}</label>
                                <Field name="cre_convener_phone" type="tel" class="form-control"
                                    :placeholder="$t('enter_convener_phone')" v-model="cre_convener_phone" />
                                <ErrorMessage name="cre_convener_phone" class="error-message" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Other Services -->
                <div class="form-card">
                    <div class="form-card-header">{{ $t('other_services') }}</div>
                    <div class="form-card-body">
                        <div class="form-group">
                            <label class="label">{{ $t('zakath_cell') }}</label>
                            <div class="radio-group">
                                <span class="radio-option">
                                    <Field name="has_zakath_cell" type="radio" value="yes" v-model="has_zakath_cell" />
                                    <label>{{ $t('yes_2') }}</label>
                                </span>
                                <span class="radio-option">
                                    <Field name="has_zakath_cell" type="radio" value="no" v-model="has_zakath_cell" />
                                    <label>{{ $t('no_2') }}</label>
                                </span>
                            </div>
                            <ErrorMessage name="has_zakath_cell" class="error-message" />
                        </div>

                        <div class="form-group">
                            <label class="label">{{ $t('orphan_care') }}</label>
                            <div class="radio-group">
                                <span class="radio-option">
                                    <Field name="has_orphan_care" type="radio" value="yes" v-model="has_orphan_care" />
                                    <label>{{ $t('yes_2') }}</label>
                                </span>
                                <span class="radio-option">
                                    <Field name="has_orphan_care" type="radio" value="no" v-model="has_orphan_care" />
                                    <label>{{ $t('no_2') }}</label>
                                </span>
                            </div>
                            <ErrorMessage name="has_orphan_care" class="error-message" />
                        </div>

                        <div class="form-group" v-if="has_orphan_care === 'yes'">
                            <label class="label">{{ $t('orphan_count') }}</label>
                            <Field name="orphan_count" type="number" class="form-control"
                                :placeholder="$t('enter_orphan_count')" v-model="orphan_count" />
                            <ErrorMessage name="orphan_count" class="error-message" />
                        </div>

                        <div class="form-group">
                            <label class="label">{{ $t('wisdom_healthcare') }}</label>
                            <div class="radio-group">
                                <span class="radio-option">
                                    <Field name="has_healthcare" type="radio" value="yes" v-model="has_healthcare" />
                                    <label>{{ $t('yes_2') }}</label>
                                </span>
                                <span class="radio-option">
                                    <Field name="has_healthcare" type="radio" value="no" v-model="has_healthcare" />
                                    <label>{{ $t('no_2') }}</label>
                                </span>
                            </div>
                            <ErrorMessage name="has_healthcare" class="error-message" />
                        </div>

                        <div class="form-group" v-if="has_healthcare === 'yes'">
                            <label class="label">{{ $t('main_healthcare_activities') }}</label>
                            <Field name="healthcare_activities" as="textarea" class="form-control"
                                :placeholder="$t('enter_main_healthcare_activities')" v-model="healthcare_activities" />
                            <ErrorMessage name="healthcare_activities" class="error-message" />
                        </div>

                        <div class="form-group">
                            <label class="label">{{ $t('hifdh_college') }}</label>
                            <div class="radio-group">
                                <span class="radio-option">
                                    <Field name="has_hifdh_college" type="radio" value="yes"
                                        v-model="has_hifdh_college" />
                                    <label>{{ $t('yes_2') }}</label>
                                </span>
                                <span class="radio-option">
                                    <Field name="has_hifdh_college" type="radio" value="no"
                                        v-model="has_hifdh_college" />
                                    <label>{{ $t('no_2') }}</label>
                                </span>
                            </div>
                            <ErrorMessage name="has_hifdh_college" class="error-message" />
                        </div>

                        <div class="form-group" v-if="has_hifdh_college === 'yes'">
                            <label class="label">{{ $t('hifdh_student_count') }}</label>
                            <Field name="hifdh_students_count" type="number" class="form-control"
                                :placeholder="$t('enter_hifdh_students_count')" v-model="hifdh_student_count" />
                            <ErrorMessage name="hifdh_student_count" class="error-message" />
                        </div>

                        <div class="form-group">
                            <label class="label">{{ $t('library') }}</label>
                            <div class="radio-group">
                                <span class="radio-option">
                                    <Field name="has_library" type="radio" value="yes" v-model="has_library" />
                                    <label>{{ $t('yes_2') }}</label>
                                </span>
                                <span class="radio-option">
                                    <Field name="has_library" type="radio" value="no" v-model="has_library" />
                                    <label>{{ $t('no_2') }}</label>
                                </span>
                            </div>
                            <ErrorMessage name="has_library" class="error-message" />
                        </div>

                        <div class="form-group">
                            <label class="label">{{ $t('book_sale') }}</label>
                            <div class="radio-group">
                                <span class="radio-option">
                                    <Field name="has_book_sale" type="radio" value="yes" v-model="has_book_sale" />
                                    <label>{{ $t('yes_2') }}</label>
                                </span>
                                <span class="radio-option">
                                    <Field name="has_book_sale" type="radio" value="no" v-model="has_book_sale" />
                                    <label>{{ $t('no_2') }}</label>
                                </span>
                            </div>
                            <ErrorMessage name="has_book_sale" class="error-message" />
                        </div>

                        <div class="form-group">
                            <label class="label">{{ $t('peace_radio') }}</label>
                            <div class="radio-group">
                                <span class="radio-option">
                                    <Field name="has_peace_radio" type="radio" value="yes" v-model="has_peace_radio" />
                                    <label>{{ $t('yes_2') }}</label>
                                </span>
                                <span class="radio-option">
                                    <Field name="has_peace_radio" type="radio" value="no" v-model="has_peace_radio" />
                                    <label>{{ $t('no_2') }}</label>
                                </span>
                            </div>
                            <ErrorMessage name="has_peace_radio" class="error-message" />
                        </div>
                    </div>
                </div>

                <!-- Other Institutions -->
                <div class="form-card other-institutions-card">
                    <div class="form-card-header">{{ $t('other_institutions') }}</div>
                    <div class="form-card-body">
                        <div class="institution-row">
                            <span class="institution-index">1.</span>
                            <Field name="other_institution_1" type="text" class="form-control"
                                :placeholder="$t('enter_other_institution_1')" v-model="other_institution_1" />
                            <ErrorMessage name="other_institution_1" class="error-message" />
                        </div>
                        <div class="institution-row">
                            <span class="institution-index">2.</span>
                            <Field name="other_institution_2" type="text" class="form-control"
                                :placeholder="$t('enter_other_institution_2')" v-model="other_institution_2" />
                            <ErrorMessage name="other_institution_2" class="error-message" />
                        </div>
                        <div class="institution-row">
                            <span class="institution-index">3.</span>
                            <Field name="other_institution_3" type="text" class="form-control"
                                :placeholder="$t('enter_other_institution_3')" v-model="other_institution_3" />
                            <ErrorMessage name="other_institution_3" class="error-message" />
                        </div>
                    </div>
                </div>

                <!-- Submit Button -->
                <div class="save-btn-align">
                    <button type="submit" class="btn btn-primary btn-lg form-action-btn" :disabled="loading"
                        v-if="editable">
                        <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                        <span>{{ $t('save') }}</span>
                    </button>
                    <button type="button" class="btn btn-secondary btn-lg form-action-btn"
                        v-if="!editable && !add_admin" @click="closeAddMemberModel">{{ $t('close') }}</button>
                </div>
            </div>
        </Form>
    </div>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import UserService from "../../services/user.service";
import $ from 'jquery';

import AlertModel from "../layouts/AlertModel.vue";
import DialogModel from "../layouts/DialogModel.vue";
export default {
    name: 'Clustors List',
    components: {
        Form,
        Field,
        AlertModel,
        DialogModel,
        ErrorMessage
    },

    data() {
        const schema = yup.object().shape({
            // Basic Information
            has_center: yup.string().required(this.$t('field_required')),
            center_type: yup.string().when('has_center', {
                is: 'yes',
                then: yup.string().required(this.$t('building_type_required'))
            }),
            office_location: yup.string().when('has_center', {
                is: 'yes',
                then: yup.string().required(this.$t('office_location_required'))
            }),

            // Remove the problematic array field validation from schema
            // and handle it manually in validateAdditionalEntries method

            // Arabic College Details
            has_arabic_college: yup.string().required(this.$t('field_required')),
            college_affiliation: yup.string().when('has_arabic_college', {
                is: 'yes',
                then: yup.string().required(this.$t('college_affiliation_required'))
            }),
            college_name: yup.string().when('has_arabic_college', {
                is: 'yes',
                then: yup.string().required(this.$t('college_name_required'))
            }),

            // CRE Details
            has_cre: yup.string().required(this.$t('field_required')),
            cre_day: yup.string().when('has_cre', {
                is: 'yes',
                then: yup.string().required(this.$t('day_required'))
            }),
            cre_hour: yup.string().when('has_cre', {
                is: 'yes',
                then: yup.string().required(this.$t('hour_required'))
            }),
            cre_convener_phone: yup.string().when('has_cre', {
                is: 'yes',
                then: yup.string().required(this.$t('convener_phone_required'))
            }),

            // Other Services
            has_zakath_cell: yup.string().required(this.$t('field_required')),
            has_orphan_care: yup.string().required(this.$t('field_required')),
            has_healthcare: yup.string().required(this.$t('field_required')),
            has_hifdh_college: yup.string().required(this.$t('field_required')),
            has_library: yup.string().required(this.$t('field_required')),
            has_book_sale: yup.string().required(this.$t('field_required')),
            has_peace_radio: yup.string().required(this.$t('field_required')),
        });
        return {
            loading: false,
            loading_list: false,
            message: "",
            country_code: '91',
            country_code_whatsapp: '91',
            mobile_number: '',
            whatsapp_number: '',
            wing: '',
            schema,
            unit_id: '',
            stay: '',
            user_level: "",
            sub_levels: [],
            member_lists: [],
            lists: [],
            orgnal_member_lists: [],
            trash_list: [],
            unit: [],
            editable_id: '',
            editable: true,
            add_admin: false,
            abroad_fields: false,
            pin_number: '',
            deletable_id: '',
            reason_to_delete: '',
            message_delete: '',
            delete_others: false,
            delete_other_text: '',
            member_id: '',
            search_qty: '',
            verification_status_list: [],
            verification_status: '',
            not_verification_status: '',
            not_verification_status_: '',
            verification_remark: '',
            verification_member_id: '',
            verification_message: '',
            verification_report: false,
            isSubscriber: '',
            receipt_no: '',
            subscription_no: '',
            nerpatham: [],
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: [],
            verification_check: [],
            not_verification_check: [],
            country_list: [],
            isAbroad: '',
            abroadPlace: '',
            abroadCountry: '',
            lajna_member: '',
            lajna_member_id: '',
            permissions: {
                view_event_registrations: '',
                qhls: [],
                nerpatham: [],
                executives: [],
                members: [],
                verification: []
            },
            initialValues: {
                name: this.unit && this.unit.name ? this.unit.name : ''
            },
            masjids: [
                {
                    has_masjid: '',
                    masjid_affiliation: '',
                    has_jumua: '',
                    jumua_attendance: '',
                    masjid_location: '',
                    parking_capacity: '',
                    facilities: [],
                    masjid_staff_count: '',
                    imam_name: '',
                    imam_state: '',
                    imam_phone: '',
                    // wisdom_location: ''
                }
            ],
            madrasas: [
                {
                    has_madrasa: '',
                    madrasa_affiliation: '',
                    madrasa_building_type: '',
                    madrasa_name: '',
                    madrasa_started_year: '',
                    class_format: '',
                    madrasa_location: ''
                }
            ],
            // Updated QHLS to support multiple entries
            qhlsList: [
                {
                    has_qhls: '',
                    qhls_name: '',
                    qhls_location: '',
                    qhls_convener_name: '',
                    qhls_convener_phone: '',
                    qhls_day: '',
                    qhls_hour: '',
                    qhls_minute: '00',
                    qhls_period: 'AM',
                    qhls_participants_count: '',
                    qhls_started_year: '',
                    qhls_building_type: '',
                    qhls_frequency: ''
                }
            ],
            has_center: '',
            center_type: '',
            office_location: '',
            has_arabic_college: '',
            college_affiliation: '',
            college_building_type: '',
            college_name: '',
            college_started_year: '',
            courses: [],
            teacher_count: '',
            college_location: '',
            facebook_link: '',
            youtube_link: '',
            instagram_link: '',
            wisdom_media_link: '',
            wisdom_land_cents: '',
            trust_land_cents: '',
            other_land: '',
            // Remove individual QHLS fields as they're now in qhlsList array
            has_cre: '',
            cre_day: '',
            cre_hour: '',
            cre_minute: '00',
            cre_period: 'AM',
            cre_convener_phone: '',
            has_zakath_cell: '',
            has_orphan_care: '',
            orphan_count: '',
            has_healthcare: '',
            healthcare_activities: '',
            has_hifdh_college: '',
            hifdh_student_count: '',
            has_library: '',
            has_book_sale: '',
            has_peace_radio: '',
            other_institution_1: '',
            other_institution_2: '',
            other_institution_3: '',
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        // Add computed property for backward compatibility
        has_qhls() {
            return this.qhlsList.length > 0 ? this.qhlsList[0].has_qhls : '';
        }
    },
    mounted() {
        console.log(this.permissions.verification);
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = parseInt(this.$route.params.sub_level);
            this.unit_id = parseInt(this.$route.params.id);
            this.getMembersList(1);
            console.log(this.currentUser.unit_id, this.unit_id, this.currentUser.user_level);

            if ((this.unit_id == this.currentUser.unit_id) && this.currentUser.user_level <= 4) {
                this.editable = true;
            } else {
                this.editable = false;
            }
            this.$root.updateParent(this.$t('unit_data_collection'));
        }
        window.onpopstate = function () {
            if ($('body').hasClass('modal-open')) {
                location.reload();
            }
        };
    },
    methods: {
        getMembersList(wing) {
            this.loading_list = true;
            let unit_id = this.unit_id ? this.unit_id : this.currentUser.unit_id;
            UserService.authGetRequest('unit-data-collections/' + unit_id, {}).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.member_lists = response.data.data.list;
                        this.search_qty = '';
                        this.orgnal_member_lists = response.data.data.list;
                        this.trash_list = response.data.data.trash_list;
                        this.lists = response.data.data.list;
                        this.unit = response.data.data.unit;
                        this.wing = wing;
                        this.permissions = response.data.data.permissions;

                        // Set form data if unit data exists
                        if (response.data.data) {
                            this.setFormData(response.data.data);
                        }

                        this.loading_list = false;
                    } else {
                        this.loading_list = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },

        // Updated setFormData method to handle multiple QHLS
        setFormData(data) {
            // Basic Information
            this.has_center = data.has_center || '';
            this.center_type = data.center_type || '';
            this.office_location = data.office_location || '';

            // Arabic College Details
            this.has_arabic_college = data.has_arabic_college || '';
            this.college_affiliation = data.college_affiliation || '';
            this.college_building_type = data.college_building_type || '';
            this.college_name = data.college_name || '';
            this.college_started_year = data.college_started_year || '';
            this.courses = data.courses || [];
            this.teacher_count = data.teacher_count || '';
            this.college_location = data.college_location || '';

            // Social Media Details
            this.facebook_link = data.facebook_link || '';
            this.youtube_link = data.youtube_link || '';
            this.instagram_link = data.instagram_link || '';
            this.wisdom_media_link = data.wisdom_media_link || '';

            // Land and Building
            this.wisdom_land_cents = data.wisdom_land_cents || '';
            this.trust_land_cents = data.trust_land_cents || '';
            this.other_land = data.other_land || '';

            // CRE Details
            this.has_cre = data.has_cre || '';
            this.cre_day = data.cre_day || '';
            this.cre_hour = data.cre_hour || '';
            this.cre_minute = data.cre_minute || '00';
            this.cre_period = data.cre_period || 'AM';
            this.cre_convener_phone = data.cre_convener_phone || '';

            // Other Services
            this.has_zakath_cell = data.has_zakath_cell || '';
            this.has_orphan_care = data.has_orphan_care || '';
            this.orphan_count = data.orphan_count || '';
            this.has_healthcare = data.has_healthcare || '';
            this.healthcare_activities = data.healthcare_activities || '';
            this.has_hifdh_college = data.has_hifdh_college || '';
            this.hifdh_student_count = data.hifdh_student_count || '';
            this.has_library = data.has_library || '';
            this.has_book_sale = data.has_book_sale || '';
            this.has_peace_radio = data.has_peace_radio || '';

            // Other Institutions
            this.other_institution_1 = data.other_institution_1 || '';
            this.other_institution_2 = data.other_institution_2 || '';
            this.other_institution_3 = data.other_institution_3 || '';

            // Set Masjids data
            if (data.masjids && data.masjids.length > 0) {
                this.masjids = data.masjids.map(masjid => ({
                    has_masjid: masjid.has_masjid || '',
                    masjid_affiliation: masjid.masjid_affiliation || '',
                    has_jumua: masjid.has_jumua || '',
                    jumua_attendance: masjid.jumua_attendance || '',
                    masjid_location: masjid.masjid_location || '',
                    parking_capacity: masjid.parking_capacity || '',
                    facilities: masjid.facilities || [],
                    masjid_staff_count: masjid.masjid_staff_count || '',
                    imam_name: masjid.imam_name || '',
                    imam_state: masjid.imam_state || '',
                    imam_phone: masjid.imam_phone || '',
                    // wisdom_location: masjid.wisdom_location || ''
                }));
            }

            // Set Madrasas data
            if (data.madrasas && data.madrasas.length > 0) {
                this.madrasas = data.madrasas.map(madrasa => ({
                    has_madrasa: madrasa.has_madrasa || '',
                    madrasa_affiliation: madrasa.madrasa_affiliation || '',
                    madrasa_building_type: madrasa.madrasa_building_type || '',
                    madrasa_name: madrasa.madrasa_name || '',
                    madrasa_started_year: madrasa.madrasa_started_year || '',
                    class_format: madrasa.class_format || '',
                    madrasa_location: madrasa.madrasa_location || ''
                }));
            }

            // Set QHLS data - Updated to handle multiple entries
            if (data.qhls && data.qhls.length > 0) {
                this.qhlsList = data.qhls.map(qhls => ({
                    has_qhls: qhls.has_qhls || '',
                    qhls_name: qhls.qhls_name || '',
                    qhls_location: qhls.qhls_location || '',
                    qhls_convener_name: qhls.qhls_convener_name || '',
                    qhls_convener_phone: qhls.qhls_convener_phone || '',
                    qhls_day: qhls.qhls_day || '',
                    qhls_hour: qhls.qhls_hour || '',
                    qhls_minute: qhls.qhls_minute || '00',
                    qhls_period: qhls.qhls_period || 'AM',
                    qhls_participants_count: qhls.qhls_participants_count || '',
                    qhls_started_year: qhls.qhls_started_year || '',
                    qhls_building_type: qhls.qhls_building_type || '',
                    qhls_frequency: qhls.qhls_frequency || ''
                }));
            }
        },

        memberView(admin) {
            $('#addMemberModel').modal('show');
            this.name = admin.name;
            this.editable_id = admin.id;
        },
        adminDeleteChange(event) {
            if (event.target.value == 'Other') {
                this.delete_others = true;
            } else {
                this.delete_others = false;
            }
        },
        adminDelete(member) {
            var data = {
                id: member.id,
            }
            this.$swal.fire({
                title: '',
                text: "ഉറപ്പായും ഡിലീറ്റ് ചെയ്യണോ ?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    UserService.authPostRequest('delete-clusters', data).then(
                        (response) => {
                            if (response.data.status == 'success') {
                                this.deletable_id = ''
                                this.reason_to_delete = ''
                                this.delete_others = false
                                this.delete_other_text = ''
                                $('#deleteMemberModel').modal('hide');
                                this.$swal.fire(
                                    '',
                                    response.data.message,
                                    'success'
                                );
                                this.getMembersList(1);
                                this.loading = false;
                            } else if (response.data.status == 'warning') {
                                $('#deleteMemberModel').modal('hide');
                                this.$swal.fire(
                                    '',
                                    response.data.message,
                                    'warning'
                                );
                                this.getMembersList(1);
                                this.loading = false;
                            } else {
                                this.loading = true;
                            }
                        },
                        (error) => {
                            this.loading = false;
                            this.message =
                                (error.response &&
                                    error.response.data &&
                                    error.response.data.message) ||
                                error.message ||
                                error.toString();
                        }
                    );
                }
            });
        },
        memberDelete() {
            if (this.reason_to_delete) {
                this.message_delete = '';
                var data = {
                    id: this.deletable_id,
                    reason: !this.delete_others ? this.reason_to_delete : this.delete_other_text
                }
                UserService.authPostRequest('delete-members', data).then(
                    (response) => {
                        if (response.data.status == 'success') {
                            this.deletable_id = ''
                            this.reason_to_delete = ''
                            this.delete_others = false
                            this.delete_other_text = ''
                            $('#deleteMemberModel').modal('hide');
                            this.$swal.fire(
                                '',
                                response.data.message,
                                'success'
                            );
                            this.getMembersList(1);
                            this.loading = false;
                        } else if (response.data.status == 'warning') {
                            $('#deleteMemberModel').modal('hide');
                            this.$swal.fire(
                                '',
                                response.data.message,
                                'warning'
                            );
                            this.getMembersList(1);
                            this.loading = false;
                        } else {
                            this.loading = true;
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.message =
                            (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                            error.message ||
                            error.toString();
                    }
                );
            } else {
                this.message_delete = 'ഡിലീറ്റ് ചെയ്യാനുള്ള കാരണം സെലക്ട് ചെയ്യുക';
            }
        },
        showActionModel() {
            this.pin_number = '';
        },
        getPin(member) {
            this.loading = true;
            this.pin_number = '';
            var user = {
                id: member.id
            }
            UserService.authPostRequest('get-pin', user).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.pin_number = response.data.data.pin;
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    if (error)
                        this.loading = false;
                }
            );
        },
        adminAdd() {
            $('#addMemberModel').modal('show');
            this.wing = '';
            this.mobile_number = '';
            this.name = '';
            this.country_code = '91';
            this.editable_id = null;
            this.add_admin = true;
        },
        // Updated addMember method to include custom validation
        addMember(user) {
            // Custom validation for additional entries
            const validationErrors = this.validateAdditionalEntries();
            if (validationErrors.length > 0) {
                this.message = validationErrors[0];
                this.loading = false;
                return;
            }

            const formData = {
                ...user,
                id: this.editable_id,
                unit_id: this.unit_id ? this.unit_id : this.currentUser.unit_id,
                added_by: this.currentUser.id,
                masjids: this.masjids,
                madrasas: this.madrasas,
                qhls: this.qhlsList,
                has_center: this.has_center,
                center_type: this.center_type,
                office_location: this.office_location,
                has_arabic_college: this.has_arabic_college,
                college_affiliation: this.college_affiliation,
                college_building_type: this.college_building_type,
                college_name: this.college_name,
                college_started_year: this.college_started_year,
                courses: this.courses,
                teacher_count: this.teacher_count,
                college_location: this.college_location,
                facebook_link: this.facebook_link,
                youtube_link: this.youtube_link,
                instagram_link: this.instagram_link,
                wisdom_media_link: this.wisdom_media_link,
                wisdom_land_cents: this.wisdom_land_cents,
                trust_land_cents: this.trust_land_cents,
                other_land: this.other_land,
                has_cre: this.has_cre,
                cre_day: this.cre_day,
                cre_hour: this.cre_hour,
                cre_minute: this.cre_minute,
                cre_period: this.cre_period,
                cre_convener_phone: this.cre_convener_phone,
                has_zakath_cell: this.has_zakath_cell,
                has_orphan_care: this.has_orphan_care,
                orphan_count: this.orphan_count,
                has_healthcare: this.has_healthcare,
                healthcare_activities: this.healthcare_activities,
                has_hifdh_college: this.has_hifdh_college,
                hifdh_student_count: this.hifdh_student_count,
                has_library: this.has_library,
                has_book_sale: this.has_book_sale,
                has_peace_radio: this.has_peace_radio,
                other_institution_1: this.other_institution_1,
                other_institution_2: this.other_institution_2,
                other_institution_3: this.other_institution_3
            };

            this.loading = true;
            this.message = '';

            UserService.authPostRequest('unit-data-collections', formData).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.$swal.fire('', response.data.message, 'success');
                        this.getMembersList(this.wing || 1);
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.message = response.data.message;
                        this.loading = false;

                        // Scroll to error message
                        setTimeout(() => {
                            const errorElement = document.querySelector('.error-feedback');
                            if (errorElement) {
                                errorElement.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center'
                                });
                            }
                        }, 100);
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();

                    // Scroll to error message
                    setTimeout(() => {
                        const errorElement = document.querySelector('.error-feedback');
                        if (errorElement) {
                            errorElement.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center'
                            });
                        }
                    }, 100);
                }
            );
        },
        closeAddMemberModel() {
            $('#addMemberModel').modal('hide');
        },
        addMasjid() {
            this.masjids.push({
                has_masjid: 'yes',
                masjid_affiliation: '',
                has_jumua: '',
                jumua_attendance: '',
                masjid_location: '',
                parking_capacity: '',
                facilities: [],
                masjid_staff_count: '',
                imam_name: '',
                imam_state: '',
                imam_phone: '',
                // wisdom_location: ''
            });
        },
        removeMasjid(idx) {
            this.masjids.splice(idx, 1);
        },
        addMadrasa() {
            this.madrasas.push({
                has_madrasa: 'yes',
                madrasa_affiliation: '',
                madrasa_building_type: '',
                madrasa_name: '',
                madrasa_started_year: '',
                class_format: '',
                madrasa_location: ''
            });
        },
        removeMadrasa(idx) {
            this.madrasas.splice(idx, 1);
        },
        // New methods for handling multiple QHLS entries
        addQhls() {
            this.qhlsList.push({
                has_qhls: 'yes',
                qhls_name: '',
                qhls_location: '',
                qhls_convener_name: '',
                qhls_convener_phone: '',
                qhls_day: '',
                qhls_hour: '',
                qhls_minute: '00',
                qhls_period: 'AM',
                qhls_participants_count: '',
                qhls_started_year: '',
                qhls_building_type: '',
                qhls_frequency: ''
            });
        },
        removeQhls(idx) {
            this.qhlsList.splice(idx, 1);
        },
        handleFormSubmit(values, { setErrors }) {
            this.loading = true;
            this.message = '';

            // Manual validation for dynamic arrays
            const customErrors = this.validateFormData();

            if (Object.keys(customErrors).length > 0) {
                setErrors(customErrors);
                this.loading = false;

                // Scroll to first error
                const firstErrorField = Object.keys(customErrors)[0];
                this.scrollToField(firstErrorField);

                this.message = `Please fill in all required fields`;
                this.$swal.fire(
                    '',
                    this.message,
                    'warning'
                );
                return;
            }

            // If validation passes, submit the form
            this.addMember(values);
        },

        validateFormData() {
            const errors = {};

            // Validate first masjid entry
            if (!this.masjids[0].has_masjid) {
                errors['masjids[0].has_masjid'] = 'This field is required';
            }

            // Validate masjid details if has_masjid is 'yes'
            if (this.masjids[0].has_masjid === 'yes') {
                this.masjids.forEach((masjid, index) => {
                    if (!masjid.masjid_affiliation) {
                        errors[`masjids[${index}].masjid_affiliation`] = 'Masjid affiliation is required';
                    }
                    if (!masjid.masjid_location) {
                        errors[`masjids[${index}].masjid_location`] = 'Masjid location is required';
                    }
                    if (!masjid.has_jumua) {
                        errors[`masjids[${index}].has_jumua`] = 'This field is required';
                    }
                    if (!masjid.imam_name) {
                        errors[`masjids[${index}].imam_name`] = 'Imam name is required';
                    }
                    if (!masjid.imam_phone) {
                        errors[`masjids[${index}].imam_phone`] = 'Imam phone is required';
                    }
                });
            }

            // Validate first madrasa entry
            if (!this.madrasas[0].has_madrasa) {
                errors['madrasas[0].has_madrasa'] = 'This field is required';
            }

            // Validate madrasa details if has_madrasa is 'yes'
            if (this.madrasas[0].has_madrasa === 'yes') {
                this.madrasas.forEach((madrasa, index) => {
                    if (!madrasa.madrasa_affiliation) {
                        errors[`madrasas[${index}].madrasa_affiliation`] = 'Madrasa affiliation is required';
                    }
                    if (!madrasa.madrasa_name) {
                        errors[`madrasas[${index}].madrasa_name`] = 'Madrasa name is required';
                    }
                    if (!madrasa.madrasa_location) {
                        errors[`madrasas[${index}].madrasa_location`] = 'Madrasa location is required';
                    }
                });
            }

            // Validate first QHLS entry
            if (!this.qhlsList[0].has_qhls) {
                errors['qhls[0].has_qhls'] = 'This field is required';
            }

            // Validate QHLS details if has_qhls is 'yes'
            if (this.qhlsList[0].has_qhls === 'yes') {
                this.qhlsList.forEach((qhls, index) => {
                    if (!qhls.qhls_name) {
                        errors[`qhls[${index}].qhls_name`] = 'QHLS name is required';
                    }
                    if (!qhls.qhls_location) {
                        errors[`qhls[${index}].qhls_location`] = 'QHLS location is required';
                    }
                    if (!qhls.qhls_convener_name) {
                        errors[`qhls[${index}].qhls_convener_name`] = 'Convener name is required';
                    }
                    if (!qhls.qhls_convener_phone) {
                        errors[`qhls[${index}].qhls_convener_phone`] = 'Convener phone is required';
                    }
                    if (!qhls.qhls_day) {
                        errors[`qhls[${index}].qhls_day`] = 'Day is required';
                    }
                    if (!qhls.qhls_hour) {
                        errors[`qhls[${index}].qhls_hour`] = 'Hour is required';
                    }
                });
            }

            return errors;
        },

        // Update the scrollToField method to handle array field names properly
        scrollToField(fieldName) {
            setTimeout(() => {
                // For array field names like "masjids[0].has_masjid", use attribute selector without escaping
                let errorElement = null;

                // First, try to find the element by iterating through all form elements
                const allInputs = document.querySelectorAll('input, select, textarea');
                for (let input of allInputs) {
                    if (input.getAttribute('name') === fieldName) {
                        errorElement = input;
                        break;
                    }
                }

                // If not found, try using querySelector with proper attribute selector
                if (!errorElement) {
                    try {
                        errorElement = document.querySelector(`[name="${fieldName}"]`);
                    } catch (e) {
                        // If selector fails, ignore and use the DOM iteration result
                        console.warn('CSS selector failed for field:', fieldName);
                    }
                }

                if (errorElement) {
                    const formGroup = errorElement.closest('.form-group') ||
                        errorElement.closest('.form-card') ||
                        errorElement;

                    formGroup.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });

                    // Highlight the field
                    errorElement.style.borderColor = '#dc3545';
                    errorElement.classList.add('is-invalid');

                    // Focus on the field if it's focusable
                    if (errorElement.focus) {
                        errorElement.focus();
                    }

                    // Remove highlight after 3 seconds
                    setTimeout(() => {
                        errorElement.style.borderColor = '';
                        errorElement.classList.remove('is-invalid');
                    }, 3000);
                } else {
                    console.warn('Could not find field:', fieldName);
                }
            }, 100);
        },

        // Update the scrollToFirstError method
        scrollToFirstError(validationErrors) {
            if (validationErrors && validationErrors.length > 0) {
                const firstErrorPath = validationErrors[0].path;
                this.scrollToField(firstErrorPath);
            }
        },

        // Update the onInvalidSubmit method
        onInvalidSubmit({ errors }) {
            console.log('Validation errors:', errors);

            const firstErrorField = Object.keys(errors)[0];

            if (firstErrorField) {
                this.scrollToField(firstErrorField);

                // Show a more user-friendly error message
                this.message = 'Please fill in all required fields';

                // Scroll to error message
                setTimeout(() => {
                    const errorElement = document.querySelector('.error-feedback');
                    if (errorElement) {
                        errorElement.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                    }
                }, 200);
            }
        },

        // Update the validateAdditionalEntries method to use proper field scrolling
        validateAdditionalEntries() {
            const errors = [];

            // Validate additional masjids
            if (this.masjids[0]?.has_masjid === 'yes' && this.masjids.length > 1) {
                for (let i = 1; i < this.masjids.length; i++) {
                    const masjid = this.masjids[i];
                    if (!masjid.masjid_affiliation) {
                        errors.push(`Masjid ${i + 1}: Affiliation is required`);
                        this.scrollToField(`masjids[${i}].masjid_affiliation`);
                        break;
                    }
                    if (!masjid.masjid_location) {
                        errors.push(`Masjid ${i + 1}: Location is required`);
                        this.scrollToField(`masjids[${i}].masjid_location`);
                        break;
                    }
                    if (!masjid.has_jumua) {
                        errors.push(`Masjid ${i + 1}: Jumua status is required`);
                        this.scrollToField(`masjids[${i}].has_jumua`);
                        break;
                    }
                    if (!masjid.imam_name) {
                        errors.push(`Masjid ${i + 1}: Imam name is required`);
                        this.scrollToField(`masjids[${i}].imam_name`);
                        break;
                    }
                    if (!masjid.imam_phone) {
                        errors.push(`Masjid ${i + 1}: Imam phone is required`);
                        this.scrollToField(`masjids[${i}].imam_phone`);
                        break;
                    }
                }
            }

            // Validate additional madrasas
            if (this.madrasas[0]?.has_madrasa === 'yes' && this.madrasas.length > 1) {
                for (let i = 1; i < this.madrasas.length; i++) {
                    const madrasa = this.madrasas[i];
                    if (!madrasa.madrasa_affiliation) {
                        errors.push(`Madrasa ${i + 1}: Affiliation is required`);
                        this.scrollToField(`madrasas[${i}].madrasa_affiliation`);
                        break;
                    }
                    if (!madrasa.madrasa_name) {
                        errors.push(`Madrasa ${i + 1}: Name is required`);
                        this.scrollToField(`madrasas[${i}].madrasa_name`);
                        break;
                    }
                    if (!madrasa.madrasa_location) {
                        errors.push(`Madrasa ${i + 1}: Location is required`);
                        this.scrollToField(`madrasas[${i}].madrasa_location`);
                        break;
                    }
                }
            }

            // Validate additional QHLS
            if (this.qhlsList[0]?.has_qhls === 'yes' && this.qhlsList.length > 1) {
                for (let i = 1; i < this.qhlsList.length; i++) {
                    const qhls = this.qhlsList[i];
                    if (!qhls.qhls_name) {
                        errors.push(`QHLS ${i + 1}: Name is required`);
                        this.scrollToField(`qhls[${i}].qhls_name`);
                        break;
                    }
                    if (!qhls.qhls_location) {
                        errors.push(`QHLS ${i + 1}: Location is required`);
                        this.scrollToField(`qhls[${i}].qhls_location`);
                        break;
                    }
                    if (!qhls.qhls_convener_name) {
                        errors.push(`QHLS ${i + 1}: Convener name is required`);
                        this.scrollToField(`qhls[${i}].qhls_convener_name`);
                        break;
                    }
                    if (!qhls.qhls_convener_phone) {
                        errors.push(`QHLS ${i + 1}: Convener phone is required`);
                        this.scrollToField(`qhls[${i}].qhls_convener_phone`);
                        break;
                    }
                    if (!qhls.qhls_day) {
                        errors.push(`QHLS ${i + 1}: Day is required`);
                        this.scrollToField(`qhls[${i}].qhls_day`);
                        break;
                    }
                    if (!qhls.qhls_hour) {
                        errors.push(`QHLS ${i + 1}: Hour is required`);
                        this.scrollToField(`qhls[${i}].qhls_hour`);
                        break;
                    }
                }
            }

            return errors;
        },

        // Alternative method: Find element by name attribute using DOM traversal
        findElementByName(fieldName) {
            const allInputs = document.querySelectorAll('input, select, textarea');
            for (let input of allInputs) {
                if (input.getAttribute('name') === fieldName) {
                    return input;
                }
            }
            return null;
        },
    },
};
</script>
<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.form-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 0rem;
    justify-content: center;
}

.form-card {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
    margin-bottom: 1rem;
    min-width: 320px;
    max-width: 600px;
    width: 100%;
    display: flex;
    flex-direction: column;
}

.form-card-header {
    background: #f7f9fa;
    border-bottom: 1px solid #e0e0e0;
    border-radius: 12px 12px 0 0;
    font-size: 1.2rem;
    font-weight: 600;
    padding: 0.75rem 1rem;
    color: #003772;
}

.form-card-body {
    padding: 1rem;
}

.form-group {
    margin-bottom: 0.75rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.form-group label {
    font-weight: 500;
    margin-bottom: 0.25rem;
    margin-left: 0;
    font-size: 1rem;
    color: #222;
}

.radio-group {
    display: flex;
    flex-direction: row;
    margin-top: 0.25rem;
    margin-left: 1.2rem;
}

.radio {
    gap: 10px;
    font-size: 1rem;
    color: #222;
}

.radio-group {
    display: flex;
    flex-direction: row;
    margin-top: 0.25rem;
    margin-left: 1.2rem;
}

.radio {
    gap: 10px;
}

.radio-group input[type="radio"] {
    margin-right: 0.5rem;
}

.radio-group label {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    font-weight: 400;
    font-size: 1rem;
    margin-bottom: 0;
    color: #333;
}

.checkbox-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 0.25rem;
    margin-left: 1.2rem;
}

.checkbox-group label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 400;
    font-size: 1rem;
    margin-bottom: 0;
    color: #333;
}

input[type="text"],
input[type="number"],
input[type="tel"],
input[type="url"],
select,
textarea {
    width: 100%;
    padding: 0.5rem 0.75rem;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 1rem;
    margin-top: 0.15rem;
    margin-bottom: 0.1rem;
    box-sizing: border-box;
}

input[type="radio"],
input[type="checkbox"] {
    accent-color: #003772;
    margin-right: 0.3em;
}

.form-action-btn {
    width: 100%;
    margin-top: 1rem;
}

@media (max-width: 900px) {
    .form-grid {
        flex-direction: column;
        gap: 0rem;
        align-items: stretch;
    }

    .form-card {
        min-width: unset;
        max-width: unset;
    }
}

.mal-text {
    font-style: italic;
    color: #666;
}

.other-institutions-card {
    margin-bottom: 0;
}

.institution-row {
    display: flex;
    align-items: center;
    margin-bottom: 0.75rem;
}

.institution-index {
    min-width: 2em;
    font-weight: 500;
    font-size: 1.1em;
    color: #003772;
    margin-right: 0.5em;
    text-align: right;
}

.save-btn-align {
    width: 100%;
    max-width: 600px;
    margin: 1rem auto 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;
}

.save-btn-align .form-action-btn {
    width: 100%;
    margin: 0;
}

.d-flex {
    display: flex;
}

.justify-content-between {
    justify-content: space-between;
}

.align-items-center {
    align-items: center;
}

.ms-auto {
    margin-left: auto;
}

.mt-2 {
    margin-top: 0.5rem;
}

.radio-group .radio-option {
    display: flex;
    align-items: center;
    margin-right: 1rem;
}

.mx-1 {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
}

.ms-2 {
    margin-left: 0.5rem;
}

.mb-2 {
    margin-bottom: 0.5rem;
}

/* Add to your <style> section */
.error-message {
    color: #dc3545;
    font-size: 0.875rem;
    margin-top: 0.25rem;
    display: block;
}

.form-group {
    margin-bottom: 1rem;
}

.form-control.is-invalid {
    border-color: #dc3545;
}

/* Update input styling to show validation state */
.form-control.is-invalid:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
</style>